module.exports = __webpack_public_path__ + "static/media/press_content_08.0ed963de.png";